/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-01 13:51:51
 * @modify date 2022-12-01 13:51:51
 * @desc [description]
 */

import { Helmet } from 'react-helmet';

// Material-ui
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useDarkModeActive, useIsMobile } from '../../../hooks/Utils'

const Home = () => {
    const isMobile = useIsMobile();
    const isDarkModeActive = useDarkModeActive();

    return (
        <div className="Home--container">
            <Helmet>
                <title>Paige Hart</title>
                <link rel="canonical" href="https://paigehart.com" />
            </Helmet>

            <Grid className="Home--content-container" container>
                {isMobile &&
                    <Grid item xs={12}>
                        <img
                            className="Home--introduction-img-mobile"
                            height="300"
                            width="auto"
                            src={isDarkModeActive
                                ? 'https://ucarecdn.com/85775791-44c1-40cf-b40a-70730412865d/-/preview/-/quality/smart/-/format/webp/'
                                : 'https://ucarecdn.com/64754a08-90a3-40d4-b184-6b20eb652fd5/-/preview/-/quality/smart/-/format/webp/'
                            }
                            alt="Drawn portrait of Paige Hart" />
                    </Grid>
                }
                <Grid item xs={12} md={8}>
                    <div className="Home--introduction">
                        <Typography variant="h1" style={{ fontSize: '32px' }} gutterBottom>
                            Welcome,
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            Come on in, grab a hot drink, relax and allow me to introduce myself.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            My name is Paige, I am from Portsmouth, England and I am an artist, and a writer.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            Poetry is my biggest love. It has always been an escape for me, a way to empty my head of all the thoughts and feeling jumbled inside and try to present them in a way that is not only therapeutic for me, but is hopefully also relatable for the reader.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            For years, the idea of letting my words out into the world terrified me. The thought of broadcasting what is my heart and soul to everybody left me cowering in a corner, clutching my notebook to my chest and refusing to let anybody see. But as I’ve grown, and felt my writing grow alongside me, I’m ready to open up to the world and allow everybody to see.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            So here I am, saying hello to the world and opening up this site as a safe space for everybody to enjoy, a place for me to pour my poetry into the world, share bits and pieces of me and my mind and just write.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            I’m thrilled to have you along for the ride!
                        </Typography>
                        <img
                            className="Home--introduction-signature"
                            height="100"
                            width="auto"
                            src={isDarkModeActive
                                ? 'https://ucarecdn.com/4aeaf16b-71c3-4df1-9c95-d18b9e016469/-/preview/-/quality/smart/-/format/webp/'
                                : 'https://ucarecdn.com/4ef2216e-c6c1-44a7-971d-cdb87bfae188/-/preview/-/quality/smart/-/format/webp/'
                            }
                            alt="Paige Louise Hart signature" />
                    </div>
                </Grid>
                {!isMobile &&
                    <Grid item md={4}>
                        <img
                            className="Home--introduction-img-desktop"
                            height="500"
                            width="auto"
                            src={isDarkModeActive
                                ? 'https://ucarecdn.com/85775791-44c1-40cf-b40a-70730412865d/-/preview/-/quality/smart/-/format/webp/'
                                : 'https://ucarecdn.com/64754a08-90a3-40d4-b184-6b20eb652fd5/-/preview/-/quality/smart/-/format/webp/'
                            }
                            alt="Drawn portrait of Paige Hart" />
                    </Grid>
                }
            </Grid>
        </div>
    )
}

export default Home;